import { Brick, BrickContext, registerBrick, ErrorFlow, Query, Predicate } from 'olympe';
import AndritzUser from '../../../models/AndritzUser';
import { createAndritzUser } from './function/andritzUserCtr';

export default class CreateAndritzUser extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} fullName
     * @param {string} password
     * @param {string} confirmPassword
     * @param {*} role
     * @param {string} userName
     * @param {number} passwordMinLength
     * @param {function()} forwardEvent
     * @param {function(*)} setErrorFlow
     */
    async update(
        $,
        [fullName, password, confirmPassword, role, userName, passwordMinLength],
        [forwardEvent, setErrorFlow]
    ) {
        const validUsernameRegex = /^[a-zA-Z0-9\-_.]+$/;

        // Ensure values are valid
        // -- Username
        if (!userName || !userName.match(validUsernameRegex)) {
            setErrorFlow(ErrorFlow.create(`Invalid username.`, 0));
            return;
        }

        // Ensure userName is unique
        const userExists = await Query.instancesOf(AndritzUser)
            .filter(Predicate.equals(AndritzUser.usernameProp, userName))
            .execute();

        if (userExists.size() > 0) {
            setErrorFlow(ErrorFlow.create(`User name ${userName} already exists`, 0));
            return;
        }

        // -- Password
        if (!password || !confirmPassword) {
            setErrorFlow(ErrorFlow.create(`Missing password.`, 0));
            return;
        } else if (password.length < passwordMinLength) {
            setErrorFlow(
                ErrorFlow.create(`Password mus have at least ${passwordMinLength} characters.`, 0)
            );
            return;
        } else if (password !== confirmPassword) {
            setErrorFlow(ErrorFlow.create(`Please make sure your passwords match.`, 0));
            return;
        }

        // -- FullName : add default value if empty
        fullName = fullName && fullName.length > 0 ? fullName : userName;

        if (!role) {
            setErrorFlow(ErrorFlow.create(`No role specified.`, 0));
            return;
        }

        createAndritzUser(userName, password, fullName, role)
            .then(() => {
                forwardEvent();
            })
            .catch((error) => {
                setErrorFlow(ErrorFlow.create(error, 1));
            });
    }
}

registerBrick('018a5df5c6dee7131e54', CreateAndritzUser);
